// styles
import styles from './text-image.module.scss';

// types
import type {
  ComponentsByPositionType,
  MediaPositionType,
  MediaPositionTypeFull,
  TextImageLayoutPositioningType,
} from '.';
import type { ThemeNameProps } from 'themes';

// components
import { LeftRight } from './Views/left-right';
import { Full } from './Views/full';
import { Oversize } from './Views/oversize';
import { Panorama } from './Views/panorama';
import { LeftRightSmall } from './Views/left-right-small';

// utils
import { isEmpty } from 'utils/is-empty';
import { decodingContent } from 'utils/decodingContent';

export const aboveHeadline = {
  NORD: 'h2',
  KOLO: 'h2',
  TWYFORD: 'h2',
  XY: 'h2',
};

export const contentHeadline = {
  GDDS: 'h2',
  NORD: 'h3',
  KOLO: 'h3',
  TWYFORD: 'h3',
  XY: 'h3',
} as const;

export const imageStyles = {
  left: styles.left,
  left_small: styles.left,
  right: styles.right,
  right_small: styles.right,
  left_big: styles.leftBig,
  right_big: styles.rightBig,
  full: styles.full,
  oversize: styles.oversize,
  panorama: styles.panorama,
};

export const fullGridSize = {
  GDDS: 'twoThird',
  NORD: 'gddsFullGrid',
  KOLO: 'gddsFullGrid',
  TWYFORD: 'gddsFullGrid',
  XY: 'gddsFullGrid',
};

const fullTypeGridSize = {
  full: '10',
  full_large: '12',
  full_small: '8',
};

export function getFullGridSize(mediaPosition: MediaPositionTypeFull): number {
  const size = Number(fullTypeGridSize[mediaPosition]);
  return size;
}

const groupComponentsByPosition: TextImageLayoutPositioningType = {
  left: LeftRight,
  right: LeftRight,
  left_big: LeftRight,
  right_big: LeftRight,
  full: Full,
  oversize: Oversize,
  panorama: Panorama,
};

const nordComponentsByPosition: TextImageLayoutPositioningType = {
  left: LeftRight,
  right: LeftRight,
  left_small: LeftRightSmall,
  right_small: LeftRightSmall,
  full_large: Full,
  full: Full,
  full_small: Full,
  none: Full,
};

const componentsByPosition: ComponentsByPositionType = {
  GDDS: groupComponentsByPosition,
  XY: nordComponentsByPosition,
  NORD: nordComponentsByPosition,
  KOLO: nordComponentsByPosition,
  TWYFORD: nordComponentsByPosition,
};

export function getComponentsByPosition({
  theme,
  mediaPosition,
}: {
  mediaPosition: MediaPositionType;
  theme: ThemeNameProps;
}): React.FC<TextImageLayoutPositioningType> {
  return componentsByPosition[theme][mediaPosition];
}

export function checkHasImage(pictureObject, images, mediaItems, isNordOrKolo) {
  return (
    !!pictureObject?.url ||
    (isNordOrKolo && !isEmpty(images)) ||
    (isNordOrKolo && !isEmpty(mediaItems))
  );
}

export function getPosition(mediaPosition, imagePosition, columns) {
  return mediaPosition || imagePosition || (!isEmpty(columns) && 'columns');
}

export function getTitleContent(
  isKoloOrNord: boolean,
  title: string,
  subline?: string,
  aboveHeadline?: string,
) {
  if (isKoloOrNord) {
    return aboveHeadline ? title : decodingContent(subline);
  } else {
    return aboveHeadline ? (subline ?? '') : title;
  }
}

export function getSubtitleContent(
  isKoloOrNord: boolean,
  subtitle?: string,
  aboveHeadline?: string,
) {
  if (isKoloOrNord) {
    return aboveHeadline ? (decodingContent(subtitle) ?? '') : '';
  } else {
    return aboveHeadline ? '' : (decodingContent(subtitle) ?? '');
  }
}
